import { render, staticRenderFns } from "./passGroupDetails.vue?vue&type=template&id=13d5f7f7&scoped=true"
import script from "./passGroupDetails.vue?vue&type=script&lang=js"
export * from "./passGroupDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d5f7f7",
  null
  
)

export default component.exports